export default function usePieChartOptions() {
    return {
        chart: {
            type: 'pie',
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    format: '{point.name}<br>{point.percentage:.1f} %',
                },
            },
        },
    };
}
